/**
 * Positions a dropdown panel with fixed coordinates anchored to a trigger element.
 * Keeps the panel inside the viewport so opening a filter near the page edge does
 * not introduce horizontal scroll or layout shift from overflow.
 */
export function positionAnchoredPanel(panel, anchorEl, { gap = 6, margin = 8 } = {}) {
  panel.style.position = "fixed";
  panel.style.zIndex = "50";
  panel.style.maxWidth = `${Math.min(384, window.innerWidth - margin * 2)}px`;

  const anchorRect = anchorEl.getBoundingClientRect();
  const panelRect = panel.getBoundingClientRect();
  const panelWidth = panelRect.width || 280;
  const panelHeight = panelRect.height;

  let left = anchorRect.left;
  if (left + panelWidth > window.innerWidth - margin) {
    left = Math.max(margin, anchorRect.right - panelWidth);
  }
  left = Math.max(margin, left);

  let top = anchorRect.bottom + gap;
  if (top + panelHeight > window.innerHeight - margin) {
    top = Math.max(margin, anchorRect.top - panelHeight - gap);
  }

  panel.style.left = `${left}px`;
  panel.style.top = `${top}px`;
  panel.style.right = "auto";
  panel.style.bottom = "auto";
}

export function resetAnchoredPanel(panel) {
  panel.style.position = "";
  panel.style.left = "";
  panel.style.top = "";
  panel.style.right = "";
  panel.style.bottom = "";
  panel.style.maxWidth = "";
  panel.style.zIndex = "";
}

export function bindAnchoredPanelReposition(panel, anchorEl) {
  const reposition = () => positionAnchoredPanel(panel, anchorEl);
  window.addEventListener("scroll", reposition, true);
  window.addEventListener("resize", reposition);
  return reposition;
}

export function unbindAnchoredPanelReposition(handler) {
  if (!handler) return;
  window.removeEventListener("scroll", handler, true);
  window.removeEventListener("resize", handler);
}
